import { Controller } from "@hotwired/stimulus";

// "Score against" opening + "Min AI Score" are semantically paired: a min
// score has no meaning without an opening to score against. Disable the
// score input when no opening is picked so the coupling is obvious.
export default class extends Controller {
    static targets = ["opening", "score"]

    connect() {
        this.toggle();
    }

    toggle() {
        if (!this.hasOpeningTarget || !this.hasScoreTarget) return;
        const hasOpening = this.openingTarget.value && this.openingTarget.value !== "";
        this.scoreTarget.disabled = !hasOpening;
        if (!hasOpening) this.scoreTarget.value = "";
    }
}
